import { DEFAULT_AUTHENTICATED_HEADER } from '@/utils/constants';
import axios from 'axios';

export const uploadCommentFile = async (file: File) => {
  const body = new FormData();
  body.append('file', file);
  body.append('name', file.name);
  const apiUrl = process.env.NEXT_PUBLIC_STORAGE_BACKEND;
  return await axios.post(`${apiUrl}/upload/comment`, body, {
    headers: DEFAULT_AUTHENTICATED_HEADER, // TODO: Replace with proper user data for authentication,
  });
};
